/**
 * 字体设置 - 字重可选项
 */
export const FONT_WEIGHT_OPITONS = [
  { value: 'normal', label: 'normal' },
  { value: 'bolder', label: 'bolder' },
  { value: 'lighter', label: 'lighter' },
];
